import { render } from "./mvt-pagemenu.vue?vue&type=template&id=bd9d7318"
import script from "./mvt-pagemenu.js?vue&type=script&lang=js"
export * from "./mvt-pagemenu.js?vue&type=script&lang=js"

import exportComponent from "/builds/movoto/frontend/consumer-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__